
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.375 3.75c0-1.036.84-1.875 1.875-1.875h13.5c1.035 0 1.875.84 1.875 1.875v12c0 1.035-.84 1.875-1.875 1.875H2.25A1.875 1.875 0 01.375 15.75v-12zM2.25 2.625c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h13.5c.621 0 1.125-.504 1.125-1.125v-12c0-.621-.504-1.125-1.125-1.125H2.25z","fill":"#7367F0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.75.375c.207 0 .375.168.375.375v3a.375.375 0 01-.75 0v-3c0-.207.168-.375.375-.375zm5.25 0c.207 0 .375.168.375.375v3a.375.375 0 01-.75 0v-3c0-.207.168-.375.375-.375zm5.25 0c.207 0 .375.168.375.375v3a.375.375 0 01-.75 0v-3c0-.207.168-.375.375-.375z","fill":"#7367F0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.375 3.75c0-1.036.84-1.875 1.875-1.875h13.5c1.035 0 1.875.84 1.875 1.875v1.5a.375.375 0 01-.375.375H.75a.375.375 0 01-.375-.375v-1.5zM2.25 2.625c-.621 0-1.125.504-1.125 1.125v1.125h15.75V3.75c0-.621-.504-1.125-1.125-1.125H2.25zm10.199 4.606a.375.375 0 01.523 0l1.54 1.5a.375.375 0 010 .538l-6.158 6a.375.375 0 01-.524 0l-3.592-3.5a.375.375 0 010-.538l1.54-1.5a.375.375 0 01.523 0l1.791 1.745 4.357-4.245zm.261.793l-4.356 4.245a.375.375 0 01-.524 0l-1.79-1.745-1.003.976 3.055 2.976L13.712 9l-1.002-.976z","fill":"#7367F0"}})])
          )
        }
      }
    